import { render, staticRenderFns } from "./waisongTime.vue?vue&type=template&id=640aa0dc&"
import script from "./waisongTime.vue?vue&type=script&lang=js&"
export * from "./waisongTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports